import React from 'react'
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
  Grid,
} from '@mui/material';
import ReportIcon from '@mui/icons-material/Report';

function ConfirmationDialog({
  open,
  onClose,
  onConfirm, title,
//   dialogAction,
  description,
//   yesButton,
}) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'
    >
      <DialogTitle className='text-center' id='alert-dialog-title'>
        <ReportIcon
          className='text-danger'
          style={{ width: '50px', height: '50px' }}
        />
        <br />
        <span style={{ fontSize: '18px' }}>{title}</span>
      </DialogTitle>
      <DialogContent>
        <DialogContentText
          id='alert-dialog-description'
          className='text-center'
        >
          {description}
        </DialogContentText>
        {/* {dialogAction === 'delete' && (
          <div>
            <Box
              display='flex'
              flexDirection='row'
              alignItems='center'
              gap={2}
              mb={2}
            >
              <FormControlLabel
                control={
                  <Checkbox
                    checked={selectedCheck.writeOff}
                    onChange={handleCheckbox}
                    name='writeOff'
                  />
                }
                label='Write Off'
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={selectedCheck.condemned}
                    onChange={handleCheckbox}
                    name='condemned'
                  />
                }
                label='Condemned'
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={selectedCheck.transfer}
                    onChange={handleCheckbox}
                    name='transfer'
                  />
                }
                label='Transfer'
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={selectedCheck.others}
                    onChange={handleCheckbox}
                    name='others'
                  />
                }
                label='Others'
              />
            </Box>
            {selectedCheck.others && (
              <TextField
                fullWidth
                margin='normal'
                label='Please specify'
                variant='outlined'
                value={reasonText}
                onChange={(event) => {
                  const newValue = event.target.value;
                  setReasonText(newValue);
                }}
              />
            )}
          </div>
        )} */}
      </DialogContent>
      <DialogActions>
        <Grid container spacing={2} justifyContent='center'>
          <Grid item xs={6}>
            <Button
              onClick={onConfirm}
              variant='contained'
              sx={{
                backgroundColor: '#25D366',
                '&:hover': {
                  backgroundColor: '#20C155',
                },
              }}
              fullWidth
              //   disabled={dialogAction === 'delete' && !yesButton}
            >
              Yes
            </Button>
          </Grid>
          <Grid item xs={6}>
            <Button
              onClick={onClose}
              variant='contained'
              sx={{
                backgroundColor: '#E31937',
                '&:hover': {
                  backgroundColor: '#C21831',
                },
              }}
              fullWidth
            >
              Close
            </Button>
          </Grid>
        </Grid>
      </DialogActions>
    </Dialog>
    // <Dialog open={open} onClose={onClose}>
    //   <DialogTitle>Confirm</DialogTitle>
    //   <DialogContent>{description}</DialogContent>
    //   <DialogActions>
    //     <Button onClick={onClose} color='primary'>
    //       Cancel
    //     </Button>
    //     <Button onClick={onConfirm} color='primary'>
    //       Confirm
    //     </Button>
    //   </DialogActions>
    // </Dialog>
  );
}

export default ConfirmationDialog